<template>
	<b-sidebar
		id="add-new-user-sidebar"
		:visible="isAddNewUserSidebarActive"
		bg-variant="white"
		sidebar-class="sidebar-lg"
		shadow
		backdrop
		no-header
		right
		@hidden="resetForm"
		@change="val => $emit('update:is-add-new-user-sidebar-active', val)"
	>
		<template #default="{ hide }">
			<!-- Header -->
			<div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
				<h5 class="mb-0">Выбрать столбцы</h5>

				<feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
			</div>

			<!-- BODY -->
			
		</template>
	</b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

export default {
	components: {
		BSidebar,
		BForm,
		BFormGroup,
		BFormInput,
		BFormInvalidFeedback,
		BButton,
		vSelect,

		// Form Validation
		ValidationProvider,
		ValidationObserver,
	},
	directives: {
		Ripple,
	},
	model: {
		prop: 'isAddNewUserSidebarActive',
		event: 'update:is-add-new-user-sidebar-active',
	},
	props: {
		isAddNewUserSidebarActive: {
			type: Boolean,
			required: true,
		},
		planOptions: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			required,
			alphaNum,
			email,
		}
	},
	setup(props, { emit }) {
		const blankUserData = {
			username: '',
			first_name: '',
			last_name: '',
			email: '',
			role_id: null,
		}

		const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
		const resetuserData = () => {
			userData.value = JSON.parse(JSON.stringify(blankUserData))
		}

		const onSubmit = () => {
			store.dispatch('app-user/addUser', userData.value).then(() => {
				emit('refetch-data')
				emit('update:is-add-new-user-sidebar-active', false)
			})
		}

		const { refFormObserver, getValidationState, resetForm } = formValidation(resetuserData)

		return {
			userData,
			onSubmit,

			refFormObserver,
			getValidationState,
			resetForm,
		}
	},
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
	.vs__dropdown-menu {
		max-height: 200px !important;
	}
}
</style>
